export const whitelistedSegments = [
	'arrival-amenities',
	'arrival-transportation',
	'departure-transportation',
	'transportation',
	'estimated-total',
	'welcome-amenities',
	'itinerary',
	'activity-calendar',
	'spa',
	'experiences',
	'dining',
	'discover',
];

export const isContentSegment = (additionalSegment?: string) => {
	return ['spa', 'experiences', 'dining', 'discover', 'activity-calendar'].some(segment => {
		return segment === additionalSegment?.replace('/', '');
	});
};
